import { SVGProps } from 'react'

export const WpsDividerSvg = (props: SVGProps<SVGSVGElement>) => (
  <svg
    fill='none'
    viewBox='0 0 16 16'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      clipRule='evenodd'
      d='M1 1a1 1 0 000 2h2a1 1 0 000-2H1zm0 12a1 1 0 100 2h2a1 1 0 100-2H1zm6 0a1 1 0 100 2h2a1 1 0 100-2H7zm5 1a1 1 0 011-1h2a1 1 0 110 2h-2a1 1 0 01-1-1zM6 2a1 1 0 011-1h2a1 1 0 010 2H7a1 1 0 01-1-1zm7-1a1 1 0 100 2h2a1 1 0 100-2h-2z'
      fill='#848C99'
      fillRule='evenodd'
    />
    <path d='M0 8a1 1 0 011-1h14a1 1 0 110 2H1a1 1 0 01-1-1z' fill='#2D343D' />
  </svg>
)
